var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgZomato(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#zomato_clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6578 24C19.2852 24 24.6578 18.6274 24.6578 12C24.6578 5.37258 19.2852 0 12.6578 0C6.03036 0 0.657776 5.37258 0.657776 12C0.657776 18.6274 6.03036 24 12.6578 24Z",
    fill: "#EA2130"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.657776 11.865L1.80528 11.8275C4.22028 11.7075 5.95278 11.49 7.66278 9.68248C10.4078 6.74998 17.3828 7.56748 19.8353 10.8C20.8478 12.1275 20.7878 13.17 19.6478 14.4825C16.6478 17.9325 10.0778 18.1125 7.01028 14.7825C6.54998 14.2396 5.97472 13.8059 5.32614 13.5127C4.67756 13.2196 3.97191 13.0743 3.26028 13.0875L0.687776 13.1325C0.687776 13.1325 0.657776 12.3825 0.657776 11.865Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "zomato_clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.657776)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZomato);
export default __webpack_public_path__ + "static/media/zomato.e7e836f68b4bef325a19496b92aedf61.svg";
export { ForwardRef as ReactComponent };